import React, { Fragment, useCallback } from "react";
import { View, Text, FlatList } from "react-native";
import ResponsiveContent from "../shared/responsive-content";
import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/convex-api";
import { convexQuery } from "@convex-dev/react-query";
import useResponsiveWidth from "@/elements/hooks/use-responsive-width";
import TutorChatListItem from "./tutor-chat-list-item";
import Loader from "../shared/loader";
import TutorChatEmptyState from "./tutor-chat-empty-state";

function TutorChatList() {
  const { data: chats = [], isLoading } = useQuery(
    convexQuery(api.tutor.inbox.queries.getChats, {})
  );
  const dataLength = chats.length;
  const responsiveWidth = useResponsiveWidth();

  const renderItem = useCallback(
    ({
      item,
    }: {
      item: (typeof api.tutor.inbox.queries.getChats._returnType)[number];
    }) => {
      return <TutorChatListItem chat={item} />;
    },
    []
  );

  const ListEmptyComponent = useCallback(() => {
    return isLoading ? <Loader /> : <TutorChatEmptyState />;
  }, [isLoading]);

  const ListFooterComponent = useCallback(() => {
    return (
      <Fragment>
        {dataLength > 0 && <View className="h-[1px] bg-gray-200" />}
        <View className="h-[75px]" />
      </Fragment>
    );
  }, [dataLength]);

  const ListHeaderComponent = useCallback(() => {
    return (
      <Fragment>
        {dataLength > 0 && <View className="h-[1px] bg-gray-200" />}
      </Fragment>
    );
  }, [dataLength]);

  const ItemSeparatorComponent = useCallback(() => {
    return <View className="h-[1px] bg-gray-200" />;
  }, []);

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      <ResponsiveContent>
        <View className="h-3" />
        <View className="mx-5">
          <View className="gap-1">
            <Text className="font-zilla-slab-medium font-medium text-dark text-[28px] leading-[1.2]">
              Chats
            </Text>
            <Text className="font-geologica-regular font-normal text-[20px] text-gray-800 leading-[1.5]">
              Connect with parents of students to share information and updates.
            </Text>
          </View>
        </View>
        <View className="h-8" />
      </ResponsiveContent>
      <FlatList
        data={chats}
        renderItem={renderItem}
        style={{
          width: responsiveWidth,
          alignSelf: "center",
        }}
        ItemSeparatorComponent={ItemSeparatorComponent}
        ListEmptyComponent={ListEmptyComponent}
        contentContainerStyle={
          dataLength === 0 ? { justifyContent: "center", flex: 1 } : undefined
        }
        ListFooterComponent={ListFooterComponent}
        ListHeaderComponent={ListHeaderComponent}
      />
    </View>
  );
}

export default TutorChatList;
